export const environment = {
    name: 'dev',
    production: false,
    googleAnalytics: false,
    gravityCmsApi: 'https://dev-gravity-service.7platform.com/v1',
    authApi: 'https://dev-seven-platform.7platform.com/app_dev.php'
};
